import script from "./PWAInstallModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PWAInstallModal.vue?vue&type=script&lang=ts&setup=true"

import "./PWAInstallModal.vue?vue&type=style&index=0&id=305aeae2&scoped=true&lang=css"
import "./PWAInstallModal.vue?vue&type=style&index=1&id=305aeae2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-305aeae2"]])

export default __exports__